import {action} from "mobx";
import shiftService from "../services/shiftService";
import {b64DecodeToUrl} from "../utils/helpers";
import appStore from "./appStore";
import {message} from "antd";

class shiftStore {
    @action getShiftList = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await shiftService.getShiftList(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getShiftForOperationPage = async params => {
        const resultOfRequest = await shiftService.getShiftForOperationPage(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getSnapshotList = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await shiftService.getSnapshotList(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action downloadShiftExcelFile = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await shiftService.downloadShiftExcelFile(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return b64DecodeToUrl(resultOfRequest.data);
    };

    @action downloadShiftExcelFileSnapshot = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await shiftService.downloadShiftExcelFileSnapshot(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return b64DecodeToUrl(resultOfRequest.data);
    };

    @action deleteShift = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await shiftService.deleteShift(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest;
    };

    @action updateShift = async params => {
        try {
            const resultOfRequest = await shiftService.updateShift(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return resultOfRequest.data;
        } catch (error) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action getShiftScoreList = async params => {
        const resultOfRequest = await shiftService.getShiftScoreList(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action exportShiftScoreListByCurrentStatus = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await shiftService.exportShiftScoreListByCurrentStatus(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return b64DecodeToUrl(resultOfRequest.data);
    };

    @action getFutureShiftsList = async params => {
        const resultOfRequest = await shiftService.getFutureShiftsList(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action updateShiftCompanyAndSubCompany = async params => {
        try {
            const resultOfRequest = await shiftService.updateShiftCompanyAndSubCompany(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return true;
        } catch (error) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action updateShiftCourier = async params => {
        try {
            const resultOfRequest = await shiftService.updateShiftCourier(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest?.data?.message || ""});
                return false;
            }
            if (resultOfRequest.data?.message) {
                message.success(resultOfRequest?.data?.message);
            }
            return true;
        } catch (error) {
            appStore.openErrorModal({content: resultOfRequest?.data?.message || ""});
            return false;
        }
    };

    @action getShiftScoreObjectionList = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await shiftService.getShiftScoreObjectionList(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action createShiftScoreObjection = async params => {
        try {
            const resultOfRequest = await shiftService.createShiftScoreObjection(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return true;
        } catch (error) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action getShiftScoreObjection = async params => {
        try {
            const resultOfRequest = await shiftService.getShiftScoreObjection(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return resultOfRequest.data?.objection;
        } catch (error) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action createShiftScoreObjectionNote = async params => {
        try {
            const resultOfRequest = await shiftService.createShiftScoreObjectionNote(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return true;
        } catch (error) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action updateShiftScoreObjectionRevision = async params => {
        try {
            const resultOfRequest = await shiftService.updateShiftScoreObjectionRevision(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return true;
        } catch (error) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action updateShiftScoreObjectionApproval = async params => {
        try {
            const resultOfRequest = await shiftService.updateShiftScoreObjectionApproval(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return true;
        } catch (error) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action approveShiftReport = async params => {
        try {
            const resultOfRequest = await shiftService.approveShiftReport(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return true;
        } catch (error) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action getShiftReportByTcknAndDate = async params => {
        try {
            const resultOfRequest = await shiftService.getShiftReportByTcknAndDate(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return resultOfRequest.data;
        } catch (error) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action getShiftReportByCourierIdAndDate = async params => {
        try {
            const resultOfRequest = await shiftService.getShiftReportByCourierIdAndDate(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return resultOfRequest.data;
        } catch (error) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };
    @action getShiftCompliance = async params => {
        try {
            const resultOfRequest = await shiftService.getShiftCompliance(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return resultOfRequest.data;
        } catch (error) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action getComplianceCouriers = async params => {
        try {
            const resultOfRequest = await shiftService.getComplianceCouriers(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return resultOfRequest.data;
        } catch (error) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action getWaitingApproveCount = async params => {
        try {
            const resultOfRequest = await shiftService.getWaitingApproveCount(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return resultOfRequest.data.count;
        } catch (error) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action getObjectionsCount = async params => {
        try {
            const resultOfRequest = await shiftService.getObjectionsCount(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return resultOfRequest.data.dataCount || 0;
        } catch (error) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action getDayOffList = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await shiftService.getDayOffList(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action updateDayOff = async params => {
        try {
            const resultOfRequest = await shiftService.updateDayOff(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return true;
        } catch (error) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action updateDayOffApproval = async params => {
        try {
            const resultOfRequest = await shiftService.updateDayOffApproval(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            return true;
        } catch (error) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
    };

    @action downloadDayOffExcelFile = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await shiftService.downloadDayOffExcelFile(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return b64DecodeToUrl(resultOfRequest.data);
    };

    @action deleteDayOff = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await shiftService.deleteDayOff(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest;
    };

    @action getQuickReactionCourierList = async params => {
        const resultOfRequest = await shiftService.getQuickReactionCourierList(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };
    @action postQuickReactionCourierList = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await shiftService.postQuickReactionCourierList(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action reportShiftProblem = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await shiftService.reportShiftProblem(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action createShiftReport = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await shiftService.createShiftReport(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    // Satır bazlı hataları hata excel'i olarak döndürdüğü için 200 dışı yanıtta bile
    // errorExcel varsa hata modalı açılmaz; dosya indirilip kullanıcıya gösterilir.
    @action importShiftExcel = async params => {
        const resultOfRequest = await shiftService.importShiftExcel(params);
        const data = resultOfRequest?.data?.result || resultOfRequest?.data;
        if (resultOfRequest.status !== 200 && !data?.errorExcel) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
        }
        return {data};
    };

    @action createManuelShift = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await shiftService.createManuelShift(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };
}

export default new shiftStore();
